import { Masonry } from '@leagueplatform/masonry';
import { MASONRY } from 'common/constants';
import { usePageViewAnalytics } from '@leagueplatform/analytics';
import { useIntl } from '@leagueplatform/locales';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { MasonryPageLayout } from 'components/masonry-page-layout/masonry-page-layout.component';
import { useQueryParams } from '@leagueplatform/routing';

export const InPersonConsultationPage = () => {
  usePageViewAnalytics({ screen_name: 'Book In Person Consultation' });
  const params = useQueryParams();
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'STR_BOOK_IN_PERSON_CONSULTATION' }));

  return (
    <MasonryPageLayout showBackButton>
      <Masonry
        rootNodeId={MASONRY.ROOT_NODE_IN_PERSON_CONSULTATION_PAGE}
        initialQueryParams={Object.fromEntries(params)}
      />
    </MasonryPageLayout>
  );
};
